export const environment = {
  production: false,
  imports: [],
  api: {
    ibge: "https://servicodados.ibge.gov.br/api/v1/localidades/estados",
    mv: {
      nf: "https://staging-nf-server.api-mv.com.br/v1",
      obra: "https://staging-mod-obra.api-mv.com.br/api/vidraceiro_mv",
      zemt: "https://staging-zemt-server.api-mv.com.br/api"
    }
  },
  externals: {
    validadorTecnospeed: "https://validador.nfe.tecnospeed.com.br/",
    cnpjLookup: "https://brasilapi.com.br/api/cnpj/v1"
  }
};
